/* eslint-disable */
import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Typography,
  IconButton,
  InputAdornment
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { httpClient } from 'src/utils/HttpClient';
import { useLogin } from 'src/hooks/useLogin';
import { OK } from 'src/constants';
import Swal from 'sweetalert2';

const ConfigExpired = () => {
  // State for form values
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isExpired, setIsExpired] = useState(false); // Default to Expire

  const login = useLogin();

  // Function to toggle password visibility
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  // Function for form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = {
      username,
      password,
      isExpired,
      status: 'ยืนยัน'
    };
    // console.log('ข้อมูลที่ส่ง:', result);

    let res = await httpClient.post(`expired`, {
      expired: result.isExpired,
      username: result.username,
      password: result.password
    });

    if (res.data.result == OK) {
      res = await httpClient.get(`expired`);

      if (res.data.expired) {
        login.setExpired(true);
        window.location.href = '/newpost';
        Swal.fire('ปิดการทำงานสำเร็จ', '', 'success');
      } else {
        login.setExpired(false);
        window.location.href = '/login';
        Swal.fire('เปิดการทำงานสำเร็จ', '', 'success');
      }
    } else {
      //   login.setExpired(false);
      Swal.fire('ชื่อผู้ใช้ หรือ รหัสผ่าน ไม่ถูกต้อง', res.data.message, 'error');
    }
  };

  // Function to handle form cancellation
  const handleCancel = () => {
    setUsername('');
    setPassword('');
    setIsExpired(false);
    //alert('ยกเลิกการทำงาน');
    window.location.href = '/login';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'grey.200',
        p: 2
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          bgcolor: 'white',
          p: 4,
          borderRadius: 2,
          boxShadow: 3,
          width: '100%',
          maxWidth: 400,
          display: 'flex',
          flexDirection: 'column',
          gap: 3
        }}
      >
        <Typography variant="h5" component="h2" align="center" fontWeight="bold">
          ตั้งค่าหน้าเว็บ
        </Typography>

        {/* Username input */}
        <TextField
          label="ชื่อผู้ใช้"
          variant="outlined"
          fullWidth
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        {/* Password input with toggle button */}
        <TextField
          label="รหัสผ่าน"
          variant="outlined"
          fullWidth
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleTogglePassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        {/* Expire radio buttons */}
        <FormControl component="fieldset">
          <FormLabel component="legend">สถานะ</FormLabel>
          <RadioGroup
            row
            aria-label="status"
            name="status-radio-group"
            value={isExpired}
            onChange={(e) => setIsExpired(e.target.value === 'true')}
          >
            <FormControlLabel value={true} control={<Radio />} label="หมดอายุ" />
            <FormControlLabel value={false} control={<Radio />} label="ไม่หมดอายุ" />
          </RadioGroup>
        </FormControl>

        {/* Action buttons */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ py: 1.5 }}>
            ยืนยัน
          </Button>
          <Button
            type="button"
            variant="outlined"
            onClick={handleCancel}
            fullWidth
            sx={{ py: 1.5 }}
          >
            ยกเลิก
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ConfigExpired;
